@if (!!link()) {
  <a
    class="link"
    [class.link--x-small]="size() === 'x-small'"
    [class.link--m-small]="size() === 'm-small'"
    [class.link--small]="size() === 'small'"
    [class.link--medium]="size() === 'medium'"
    [class.link--medium-2]="size() === 'medium-2'"
    [class.link--medium-3]="size() === 'medium-3'"
    [class.link--large]="size() === 'large'"
    [class.link--primary]="type() === 'primary'"
    [class.link--secondary]="type() === 'secondary'"
    [class.link--tertiary]="type() === 'tertiary'"
    [class.link--contained]="variant() === 'contained'"
    [class.link--outlined]="variant() === 'outlined'"
    [class.link--text]="variant() === 'text'"
    [href]="link()"
    [target]="target()"
    (click)="handleClick($event)"
  >
    <ng-container *ngTemplateOutlet="linkContent" />
  </a>
} @else {
  @if (disableRedirect()) {
    <a
      class="link"
      [class.link--x-small]="size() === 'x-small'"
      [class.link--m-small]="size() === 'm-small'"
      [class.link--small]="size() === 'small'"
      [class.link--medium]="size() === 'medium'"
      [class.link--medium-2]="size() === 'medium-2'"
      [class.link--medium-3]="size() === 'medium-3'"
      [class.link--large]="size() === 'large'"
      [class.link--primary]="type() === 'primary'"
      [class.link--secondary]="type() === 'secondary'"
      [class.link--tertiary]="type() === 'tertiary'"
      [class.link--contained]="variant() === 'contained'"
      [class.link--outlined]="variant() === 'outlined'"
      [class.link--text]="variant() === 'text'"
      (click)="handleClick($event)"
    >
      <ng-container *ngTemplateOutlet="linkContent" />
    </a>
  } @else {
    <a
      class="link"
      [class.link--x-small]="size() === 'x-small'"
      [class.link--m-small]="size() === 'm-small'"
      [class.link--small]="size() === 'small'"
      [class.link--medium]="size() === 'medium'"
      [class.link--medium-2]="size() === 'medium-2'"
      [class.link--medium-3]="size() === 'medium-3'"
      [class.link--large]="size() === 'large'"
      [class.link--primary]="type() === 'primary'"
      [class.link--secondary]="type() === 'secondary'"
      [class.link--tertiary]="type() === 'tertiary'"
      [class.link--contained]="variant() === 'contained'"
      [class.link--outlined]="variant() === 'outlined'"
      [class.link--text]="variant() === 'text'"
      [routerLink]="[routerLink()]"
      (click)="handleClick($event)"
    >
      <ng-container *ngTemplateOutlet="linkContent" />
    </a>
  }
}

<ng-template #linkContent>
  @if (!!beforeIconPath() && !loading()) {
    <img class="link__icon-before" [src]="beforeIconPath()" alt="" />
  }
  <span class="link__label">{{ label() }}</span>
  @if (!!icon() && !loading()) {
    <app-svg-icon
      class="link__icon"
      [icon]="'assets/images/icon-' + icon() + '.svg'"
      [blank]="true"
    />
  }
  @if (loading()) {
    <span class="link__spinner"></span>
  }
</ng-template>
